// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"bcc6df85","365":"5a14cb5d","453":"ba61912f"}[chunkId] + ".chunk.js";
};